import { useQuery } from "@tanstack/react-query"
import axios from "axios"

const getData = async (guID?: string) => {
  const response = await axios.get(`/events/${guID}/parties/`)
  return response.data
}

export default function useGetEventParty(guID?: string) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['eventParty', guID],
    queryFn: () => getData(guID),
    enabled: !!guID
  })

  return { data, isLoading, error }
}